/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.alert-info\":\"Blue circle with the letter I\"}");